import type { ComponentProps } from "react";
import { useAuth } from "contexts/AuthContext";
import { useFeatureFlags } from "contexts/FeatureFlagContext";
import { useTranslation } from "react-i18next";

import { CompanyBadge } from "components/companyBadge";
import { NavigationBar } from "./NavigationBar";
import { Header } from "./Header";
import { UtilityMenu } from "./UtilityMenu";

type NavigationItems = ComponentProps<typeof NavigationBar>["items"];

interface AuthHeaderProps {
  displayNavigation?: boolean;
}

export function AuthHeader({ displayNavigation = true }: AuthHeaderProps) {
  const { t } = useTranslation(["general", "components"]);

  const { isLoggedIn } = useAuth();
  const { features } = useFeatureFlags();

  const searchTermsItems: NavigationItems = features.useFeSearchTerms
    ? [
        {
          label: t("components:authHeader.searchTerms"),
          path: "/search-terms",
        },
      ]
    : [];

  const navigationItems: NavigationItems = [
    {
      label: t("components:authHeader.home"),
      path: "/",
      exact: true,
    },
    { label: t("components:authHeader.books"), path: "/books" },
    ...searchTermsItems,
    { label: t("components:authHeader.codes"), path: "/codes" },
    { label: t("components:authHeader.projects"), path: "/projects" },
  ];

  return (
    <Header>
      {!isLoggedIn ? null : (
        <>
          {displayNavigation && <NavigationBar items={navigationItems} />}
          <div className="flex items-center gap-2">
            <CompanyBadge />
            <UtilityMenu />
          </div>
        </>
      )}
    </Header>
  );
}
